import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-time1",
  "use": "icon-time1-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" aria-labelledby=\"timeIconTitle\" stroke=\"#000000\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-linejoin=\"miter\" fill=\"none\" id=\"icon-time1\"> <title id=\"icon-time1_timeIconTitle\">Time</title> <circle cx=\"12\" cy=\"12\" r=\"10\" /> <polyline points=\"12 5 12 12 16 16\" /> </symbol>"
});
var result = sprite.add(symbol);
export default symbol